export default {
  'bindTo': 'this',
  'method': function(){
    alert('Aggiungi Fattura')
  },
}
